import qs from 'query-string';
import { useLocation } from 'react-router-dom';

export default function useQueryParams(defaultValue) {
  // first attempt to handle any queryParams AFTER a specified route
  const { search: routerSearch = '' } = useLocation();

  // should catch params from standard location after baseUrl
  // eslint-disable-next-line no-restricted-globals
  const { search = '' } = location;

  const parsedRouterSearch = qs.parse(routerSearch);
  const parsedSearch = qs.parse(search);
  const output = {
    ...parsedRouterSearch,
    ...parsedSearch,
  };

  return Object.entries(output)?.length > 0 ? output : defaultValue;
}
